import React from 'react';
import { Sprite, Container } from '@pixi/react';

export const Symbol = ({
  symbolSize,
  index,
  texture,
}) => {
  return (
    <Container y={symbolSize * index} x={0} zIndex={6} sortableChildren={true}>
      <Sprite
        texture={texture}
        width={symbolSize}
        height={symbolSize}
        anchor={0.5}
        name="texture"
      />
    </Container>
  );
};

export default Symbol